import { clsx } from "clsx";
import type { FC, ReactNode } from "react";

import type { ProjectActivity as ProjectActivityGql, User } from "../../graphql.js";
import { isCurrentUserActivity } from "../../redux/modules/project.js";
import { Avatar } from "../core/UserAvatar.js";
import styles from "./ProjectActivity.module.css";
import { ProjectActivityBody } from "./ProjectActivityBody.js";

export interface IProjectActivityProps {
  activity: ProjectActivityGql;
  currentUser: User;
  className?: string;
  onDeleteClicked?: (activity: ProjectActivityGql) => void;
  users: User[];
  action?: ReactNode;
}

/**
 * Renders a single activity in the activity list of the ProjectActivityPanel or in the NotificationsDrop-down or directly in an in-app alert.
 *   Renders the icon or the alias built from the name and the box for the activity.
 */
export const ProjectActivity: FC<IProjectActivityProps> = (props) => {
  const currentUserActivity = isCurrentUserActivity(props.activity, props.currentUser);

  return (
    <div
      className={clsx(styles.item, props.className)}
      key={props.activity.id}
      id={String(props.activity.id)}
      role="listitem"
      data-testid="activity-list-wrapper"
    >
      <div className={styles.thumbnail}>
        {!currentUserActivity && <Avatar key={"thumb" + props.activity.id} user={props.activity.user} size={24} />}
      </div>
      <div
        key={"inner" + props.activity.id}
        className={clsx(styles.bubble, {
          [styles.bubbleSelf]: currentUserActivity,
        })}
      >
        <ProjectActivityBody
          activity={props.activity}
          users={props.users}
          isCurrentUserActivity={currentUserActivity}
          action={props.action}
        />
      </div>
    </div>
  );
};
